export default JSON.parse(`{
  "/cdn-cgi/image/": "cloudflare",
  "/_next/image": "nextjs",
  "/_next/static": "nextjs",
  "/_vercel/image": "vercel"
}
`);
